module.exports = __webpack_public_path__ + "static/brightrainbowhamper-f2516156898b4be5b98adfa787c9257c.jpeg";